import React from 'react';
import {connect} from "react-redux";
import Loading from "../../../components/common/Loading/Loading";
import AdminFull from "../../../components/admin/AdminFull/AdminFull";
import {Link} from "react-router-dom";
import {grey400} from 'material-ui/styles/colors';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {IconMenu, IconButton, MenuItem} from 'material-ui';
import styles from './ProfilePage.css';
import style from '../../../styles/styles';
import withTranslation from "../../../hoc/withTranslation";
import {EDIT_PASSWORD_PAGE, EDIT_PROFILE_PAGE, LOGIN} from "../../../constants/routes";

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class ProfilePage extends React.Component {

    componentWillMount() {
        this.update(this.props);
    }

    componentWillUpdate(nextProps) {
        if (nextProps !== this.props) {
            this.update(nextProps)
        }
    }

    update(props) {
        if (!props.authenticated) {
            props.history.push(LOGIN);
        }
    }

    render() {
        if (this.props.loading || !this.props.user) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('account_page.account')} / {this.props.t('generic.detail')}</h3>
                    <IconMenu
                        style={styles.buttons}
                        listStyle={style.list}
                        iconButtonElement={iconButtonElement}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                    >
                        <Link to={EDIT_PROFILE_PAGE}>
                            <MenuItem>
                                {this.props.t('generic.edit')}
                            </MenuItem>
                        </Link>
                        <Link to={EDIT_PASSWORD_PAGE}>
                            <MenuItem>
                                {this.props.t('account_page.change_password')}
                            </MenuItem>
                        </Link>
                    </IconMenu>

                    <AdminFull apps={this.props.apps} admin={this.props.user} />
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.auth.loading,
        authenticated: state.auth.authenticated,
        user: state.auth.content,
        initialValue: state.auth.content,
        apps: state.apps.content
    }
}

export default connect(mapStateToProps)(withTranslation(ProfilePage));



// WEBPACK FOOTER //
// src/containers/common/ProfilePage/ProfilePage.js